import React from "react";
import { Link } from "react-router-dom";

import PanelTemplate from "../../../templates/Panel";
import Icon from "../../../components/Icon";
import { getSettingsSections } from "./sections";

export const SettingsHub = () => {
    const sections = getSettingsSections();

    return (
        <PanelTemplate id="settings-hub">
            <h1 className="settings-hub-title">Configurações</h1>
            <p className="settings-hub-subtitle">Ajustes da conta, das vendas e do site. O dia a dia fica no menu; aqui é o que se configura uma vez.</p>

            <div className="settings-hub">
                {sections.map(section => (
                    <section key={section.key} className={`settings-hub-section${section.module ? ' module' : ''}`}>
                        <h2>{section.title}</h2>
                        <div className="settings-hub-cards">
                            {section.cards.map(card => (
                                <Link key={card.to} to={card.to} className="settings-hub-card">
                                    <span className="settings-hub-icon"><Icon name={card.icon} size={18} /></span>
                                    <span className="settings-hub-texts">
                                        <b>{card.name}</b>
                                        <small>{card.description}</small>
                                    </span>
                                    <Icon name="arrow" size={16} className="settings-hub-go" />
                                </Link>
                            ))}
                        </div>
                    </section>
                ))}
            </div>
        </PanelTemplate>
    );
};

export default SettingsHub;
